import { render } from "./FolderSelector.vue?vue&type=template&id=3d8856f9&scoped=true&ts=true"
import script from "./FolderSelector.vue?vue&type=script&lang=ts"
export * from "./FolderSelector.vue?vue&type=script&lang=ts"

import "./FolderSelector.vue?vue&type=style&index=0&id=3d8856f9&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8856f9"]])

export default __exports__